(() => {
    const defaultSettings = {
        loop: true,
        speed: 700,
        effect: "fade",
        fadeEffect: {
            crossFade: true
        },
        autoplay: {
            delay: 7000,
            disableOnInteraction: false
        },
        runCallbacksOnInit: false,
        on: {
            init: function () {
                this.el.dispatchEvent(new CustomEvent('swiperReady', { detail: this }));
            }
        }
    };

    const safeParseJSON = function (str) {
        if (!str) return {};
        try { return JSON.parse(str); }
        catch (e) { console.warn("Swiper JSON parsing error:", e); return {}; }
    };

    function initialize(el) {
        if (el.swiper) return;

        let settings = Object.assign({}, defaultSettings);

        if (el.dataset.swiperEffect) {
            const bps = safeParseJSON(el.dataset.swiperEffect);
            const activeKey = Object.keys(bps)
                .map(Number)
                .sort(function (a, b) { return b - a; })
                .find(function (key) { return window.matchMedia(`(min-width: ${key}px)`).matches; });

            if (bps[activeKey]) {
                settings.effect = bps[activeKey];
            }
        }

        let sw = null;

        function attachHandlers(instance) {
            if (!instance) return;

            const indexObserverEl = instance.params.indexObserver ? document.getElementById(instance.params.indexObserver) : null;

            let syncingEls = instance.params.syncing ? document.querySelectorAll(instance.params.syncing) : [];
            let pairedEls = instance.params.pair ? document.querySelectorAll(instance.params.pair) : [];

            const total = parseInt(instance.el.dataset.total, 10) || instance.slides.length;

            let lastIndex = null;

            instance.on("realIndexChange", function () {
                const idx = this.realIndex;
                if (lastIndex === idx) return;
                lastIndex = idx;

                const logIdx = idx % total;

                if (indexObserverEl) {
                    indexObserverEl.style.setProperty("--index", logIdx + 1);

                    if (!indexObserverEl.classList.contains("no-counter")) {
                        indexObserverEl.classList.add("animating");

                        const handleTransition = function (e) {
                            if (e.propertyName !== "opacity") return;

                            indexObserverEl.dataset.index = String(logIdx + 1).padStart(2, '0');
                            indexObserverEl.classList.remove("animating");
                            indexObserverEl.removeEventListener("transitionend", handleTransition);
                            delete indexObserverEl._activeTransition;
                        };

                        if (indexObserverEl._activeTransition) {
                            indexObserverEl.removeEventListener("transitionend", indexObserverEl._activeTransition);
                        }

                        indexObserverEl._activeTransition = handleTransition;
                        indexObserverEl.addEventListener("transitionend", handleTransition);
                    }
                }

                const syncTarget = function (targetEl, offset = 0) {
                    targetEl.swiper && targetEl.swiper.slideToLoop((logIdx + offset) % total, targetEl.swiper.params.speed, false);
                };

                if (syncingEls.length)
                    syncingEls.forEach(syncTarget);

                if (pairedEls.length)
                    pairedEls.forEach(function (pairEl) {
                        const offset = (pairEl.swiper && pairEl.swiper.params.initialSlide) ? pairEl.swiper.params.initialSlide : 0;
                        syncTarget(pairEl, offset);
                    });
            });

            instance.on("destroy", function () {
                syncingEls = null;
                pairedEls = null;

                if (indexObserverEl && indexObserverEl._activeTransition)
                    indexObserverEl.removeEventListener("transitionend", indexObserverEl._activeTransition);
            });
        }

        function createInstance() {
            if (sw) return sw;
            const inlineSettings = el.dataset.swiper ? safeParseJSON(el.dataset.swiper) : {};
            sw = new Swiper(el, Object.assign({}, settings, inlineSettings));
            attachHandlers(sw);
            return sw;
        }

        function destroyInstance() {
            if (!sw) return;
            sw.destroy(true, true);
            sw = null;
        }

        if (el.dataset.swiperMedia) {
            const mediaQuery = window.matchMedia(el.dataset.swiperMedia);
            const mediaQueryHandler = function (e) { return e.matches ? createInstance() : destroyInstance(); };

            mediaQueryHandler(mediaQuery);
            mediaQuery.addEventListener("change", mediaQueryHandler);
        } else {
            createInstance();
        }
    }

    document.querySelectorAll(".swiper-slider").forEach(initialize);

    let observerTimeout;
    const domObserver = new MutationObserver(function (mutations) {
        let hasNewSwiper = false;

        mutations.forEach(mutation => {
            mutation.removedNodes.forEach(node => {
                if (node.nodeType !== 1) return;

                if (node.matches && node.matches(".swiper-slider") && node.swiper)
                    node.swiper.destroy(true, true);

                node.querySelectorAll(".swiper-slider").forEach(swiperEl => {
                    if (swiperEl.swiper) swiperEl.swiper.destroy(true, true);
                });
            });

            if (!hasNewSwiper)
                hasNewSwiper = Array.from(mutation.addedNodes).some(node =>
                    node.nodeType === 1 && (node.matches(".swiper-slider") || node.querySelector(".swiper-slider"))
                );
        });

        if (hasNewSwiper) {
            clearTimeout(observerTimeout);
            observerTimeout = setTimeout(function () {
                document.querySelectorAll(".swiper-slider:not(.swiper-initialized)").forEach(initialize);
            }, 50);
        }
    });

    domObserver.observe(document.body, { childList: true, subtree: true });
})();